import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = {
  class: "grid",
  style: {"grid-template-columns":"repeat(auto-fit,minmax(200px,1fr))","gap":"10px"}
}
const _hoisted_4 = { class: "section" }
const _hoisted_5 = {
  key: 0,
  class: "error-text"
}
const _hoisted_6 = {
  key: 2,
  class: "hint"
}
const _hoisted_7 = {
  key: 3,
  class: "list"
}
const _hoisted_8 = { class: "item-meta" }
const _hoisted_9 = { class: "item-meta" }
const _hoisted_10 = { class: "actions" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkeletonList = _resolveComponent("SkeletonList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "title" }, "Chamados"),
          _createElementVNode("p", { class: "subtitle" }, "Abertura e acompanhamento de chamados operacionais.")
        ])
      ], -1)),
      _createElementVNode("form", {
        class: "form-grid",
        onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createTicket && _ctx.createTicket(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.title) = $event)),
            type: "text",
            placeholder: "Titulo"
          }, null, 512), [
            [_vModelText, _ctx.form.title]
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.category) = $event))
          }, [...(_cache[10] || (_cache[10] = [
            _createStaticVNode("<option value=\"manutencao-ferramentas\" data-v-67716126>Manutencao de ferramentas</option><option value=\"problema-projeto\" data-v-67716126>Problema no projeto/obra</option><option value=\"solicitacao-recursos\" data-v-67716126>Solicitacao de recursos</option><option value=\"suporte-tecnico\" data-v-67716126>Suporte tecnico</option><option value=\"seguranca-trabalho\" data-v-67716126>Seguranca do trabalho</option><option value=\"outros\" data-v-67716126>Outros</option>", 6)
          ]))], 512), [
            [_vModelSelect, _ctx.form.category]
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.priority) = $event))
          }, [...(_cache[11] || (_cache[11] = [
            _createElementVNode("option", { value: "critica" }, "Critica", -1),
            _createElementVNode("option", { value: "alta" }, "Alta", -1),
            _createElementVNode("option", { value: "media" }, "Media", -1),
            _createElementVNode("option", { value: "baixa" }, "Baixa", -1)
          ]))], 512), [
            [_vModelSelect, _ctx.form.priority]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.projectId) = $event)),
            type: "text",
            placeholder: "Projeto (ID opcional)"
          }, null, 512), [
            [_vModelText, _ctx.form.projectId]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.taskId) = $event)),
            type: "text",
            placeholder: "Tarefa (ID opcional)"
          }, null, 512), [
            [_vModelText, _ctx.form.taskId]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.toolItemId) = $event)),
            type: "text",
            placeholder: "Ferramenta (ID opcional)"
          }, null, 512), [
            [_vModelText, _ctx.form.toolItemId]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.location) = $event)),
            type: "text",
            placeholder: "Localizacao"
          }, null, 512), [
            [_vModelText, _ctx.form.location]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.desiredDueDate) = $event)),
            type: "date",
            placeholder: "Prazo desejado"
          }, null, 512), [
            [_vModelText, _ctx.form.desiredDueDate]
          ])
        ]),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.description) = $event)),
          rows: "3",
          placeholder: "Descricao detalhada"
        }, null, 512), [
          [_vModelText, _ctx.form.description]
        ]),
        _cache[12] || (_cache[12] = _createElementVNode("button", {
          class: "btn btn-primary",
          type: "submit"
        }, "Novo chamado", -1))
      ], 32),
      _createElementVNode("div", _hoisted_4, [
        _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "section-title" }, "Chamados", -1)),
        (_ctx.loadError)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.loadError), 1))
          : _createCommentVNode("", true),
        (_ctx.showSkeleton)
          ? (_openBlock(), _createBlock(_component_SkeletonList, {
              key: 1,
              variant: "row",
              count: 4,
              columns: [30, 40, 20]
            }))
          : (_ctx.items.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Nenhum chamado."))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "item-card"
                  }, [
                    _createElementVNode("strong", null, _toDisplayString(item.title), 1),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(item.category) + " | prioridade: " + _toDisplayString(item.priority) + " | status: " + _toDisplayString(item.status), 1),
                    _createElementVNode("div", _hoisted_9, "Projeto: " + _toDisplayString(item.projectId || '-') + " | Tarefa: " + _toDisplayString(item.taskId || '-'), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        class: "btn btn-ghost",
                        type: "button",
                        onClick: ($event: any) => (_ctx.claim(item.id))
                      }, "Assumir", 8, _hoisted_11),
                      _createElementVNode("button", {
                        class: "btn btn-ghost",
                        type: "button",
                        onClick: ($event: any) => (_ctx.setStatus(item.id, 'em-andamento'))
                      }, "Em andamento", 8, _hoisted_12),
                      _createElementVNode("button", {
                        class: "btn btn-ghost",
                        type: "button",
                        onClick: ($event: any) => (_ctx.setStatus(item.id, 'resolvido'))
                      }, "Resolvido", 8, _hoisted_13)
                    ])
                  ]))
                }), 128))
              ]))
      ])
    ])
  ]))
}